/*
 * @Date: 2022-07-06 15:32:54
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 * @desc: 导航栏相关配置
 */
const baseLangKey = 'layout.headerBar';

export const headerList = [
  {
    name: 'home',
    langKey: baseLangKey + '.home'
  },
  {
    name: 'about',
    langKey: baseLangKey + '.about',
    children: [
      {
        pre: 'about-',
        name: 'companyProfile',
        langKey: baseLangKey + '.companyProfile'
      },
      {
        pre: 'about-',
        name: 'management',
        langKey: baseLangKey + '.management'
      },
      {
        pre: 'about-',
        name: 'corporateGovernance',
        langKey: baseLangKey + '.corporateGovernance'
      },
      {
        pre: 'about-',
        name: 'irNetwork',
        langKey: baseLangKey + '.irNetwork'
      }
    ]
  },
  {
    name: 'disclosure',
    langKey: baseLangKey + '.disclosure',
    children: [
      {
        pre: 'disclosure-',
        name: 'circulars',
        langKey: baseLangKey + '.circulars'
      },
      {
        pre: 'disclosure-',
        name: 'stockPrice',
        langKey: baseLangKey + '.stockPrice'
      }
    ]
  },
  {
    name: 'finance',
    langKey: baseLangKey + '.finance',
    children: [
      {
        pre: 'finance-',
        name: 'quarter', // 未来若打开本页面，后续需增加埋点上报逻辑代码
        langKey: baseLangKey + '.quarter'
      },
      {
        pre: 'finance-',
        name: 'year',
        langKey: baseLangKey + '.year'
      }
    ]
  },
  {
    name: 'esg',
    langKey: baseLangKey + '.esg'
  }
];
